import { render } from "./FormCounter.vue?vue&type=template&id=abedf6e0&ts=true"
import script from "./FormCounter.vue?vue&type=script&lang=ts"
export * from "./FormCounter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__